var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28026 16.8138L4.28026 1.68402C4.28026 1.14188 4.56976 0.67347 5.05467 0.431013C5.53957 0.188561 6.088 0.238013 6.52171 0.563298L16.6082 8.12818C16.9643 8.39527 17.1686 8.80376 17.1686 9.2489C17.1686 9.69405 16.9643 10.1025 16.6082 10.3696L6.52171 17.9345C6.088 18.2598 5.53957 18.3092 5.05466 18.0668C4.56976 17.8243 4.28026 17.3559 4.28026 16.8138Z",
    fill: "#46AFB8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_207_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7763 10.5939C17.2246 10.2577 17.4487 9.75334 17.4487 9.24902C17.4487 8.74469 17.2246 8.24037 16.7763 7.90415L6.68979 0.339269C5.58156 -0.491904 4.00005 0.298845 4.00005 1.68414L4.00005 16.8139C4.00005 18.1992 5.58156 18.9899 6.68979 18.1588L16.7763 10.5939ZM16.4401 8.35244C16.725 8.56611 16.8884 8.8929 16.8884 9.24902C16.8884 9.60513 16.725 9.93192 16.4401 10.1456L6.35357 17.7105C6.0066 17.9707 5.56786 18.0103 5.17993 17.8163C4.79201 17.6223 4.56042 17.2476 4.56042 16.8139L4.56042 1.68414C4.56042 1.25042 4.79201 0.875694 5.17993 0.681735C5.56786 0.487771 6.0066 0.527334 6.35357 0.78756L16.4401 8.35244Z",
    fill: "#46AFB8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_207_3",
    x: 0.0000610352,
    y: 0,
    width: 21.4487,
    height: 26.498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_207_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_207_3",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/play_btn.f3252305b4a9a8b6a33e56b723f39962.svg";
export { ForwardRef as ReactComponent };